import { Injectable } from '@angular/core';
import { DadosEstatisticosDto } from '../../dtos'
import { CaqRequestService } from '../'
import { map, firstValueFrom, forkJoin } from 'rxjs';
import { environment } from '../../../environments/environment';

interface DadosEstatisticosResponse {
  content: number
}

@Injectable({
  providedIn: 'root'
})
export class DadosEstatisticosService {
  public urlTotalMatriculas = `${environment.apiUrl}/dados-estatisticos/total-matriculas`;
  public urlTotalTurmas = `${environment.apiUrl}/dados-estatisticos/total-turmas`;
  public urlTotalProfessores = `${environment.apiUrl}/dados-estatisticos/total-professores`;
  public urlTotalAuxiliares = `${environment.apiUrl}/dados-estatisticos/total-auxiliares`;
  public urlTotalFuncionarios = `${environment.apiUrl}/dados-estatisticos/total-funcionarios`;

  constructor(private caqRequestService: CaqRequestService) {}

  async getDadosEstatisticos(): Promise<DadosEstatisticosDto> {
    return firstValueFrom(forkJoin([
      this.caqRequestService.get<DadosEstatisticosResponse>(this.urlTotalMatriculas),
      this.caqRequestService.get<DadosEstatisticosResponse>(this.urlTotalTurmas),
      this.caqRequestService.get<DadosEstatisticosResponse>(this.urlTotalProfessores),
      this.caqRequestService.get<DadosEstatisticosResponse>(this.urlTotalAuxiliares),
      this.caqRequestService.get<DadosEstatisticosResponse>(this.urlTotalFuncionarios),
    ]).pipe(map(([matriculas, turmas, professores, auxiliares, nroFuncionarios]) => ({
      totalMatriculas: matriculas.content,
      totalTurmas: turmas.content,
      totalProfessores: professores.content,
      totalAuxiliares: auxiliares.content,
      totalFuncionarios: nroFuncionarios.content,
    }))));
  }
}
